import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useField } from '@kuzmycz/react-form-ula';
import { useStyles } from '../uielements/filterMenuField/filterMenuFieldStyle';

const BioPlusSelectField = ({ name, label, values, fullWidth, isDisabled, defaultValue, ...rest }) => {
  const fieldContext = useField({ ...rest, name });
  const { error, touched } = fieldContext.errorProps;
  const classes = useStyles();
  return (
    <FormControl error={!!error && !!touched} {...rest}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        {...rest}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label={label}
        name={name}
        fullWidth={fullWidth}
        MenuProps={{ classes: { paper: classes.dropDownMaxHeight } }}
        {...fieldContext.fieldProps}
        disabled={isDisabled}
        defaultValue={defaultValue}
      >
        {values.map((data) => (
          <MenuItem value={data.value} key={data.value}>
            {data.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{touched && error}</FormHelperText>
    </FormControl>
  );
};

export default BioPlusSelectField;
